import { connect } from 'react-redux'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import RecommendedListings from './RecommendedListings'

export default connect(null, { googleAnalyticsEvent })(RecommendedListings)
